import styled from '@emotion/styled';
import React from 'react';
import { animated, useTrail } from 'react-spring';

const InputHost = styled.div`
  display: flex;
  flex-direction: column;
  & > div {
    margin-bottom: 20px;
  }
`;

export function InputContainer({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const items = React.Children.toArray(children);

  const trail = useTrail(items.length, {
    config: { mass: 2, tension: 2000, friction: 200 },
    from: {
      opacity: 0,
      x: 400,
    },
    to: { opacity: 1, x: 0 },
  });
  return (
    <InputHost className={className}>
      {trail.map(({ x, ...rest }, index) => (
        <animated.div
          key={index}
          style={{
            ...rest,
            transform: x.to((x) => `translate3d(${x}px,0,0)`),
          }}
        >
          {items[index]}
        </animated.div>
      ))}
    </InputHost>
  );
}
